
/* injects from baggage-loader */

'use strict';

import pendingToConfirmCompanyTemplate from './pendingToConfirmCompany.html';

/**
* Function that register the all routes for the pendingToConfirmCompany module.
*
* @param {any} $q
* @param {any} $ocLazyLoad
* @param {any} routerHelper
*/
function routeConfig($q, $ocLazyLoad, routerHelper, navigationConstant) {
	'ngInject';

	/**
	* Route definition of the pendingToConfirmCompany page.
	*/
	const indexNav = 6;
	const indexSubmenu = 8;
	const pendingToConfirmCompanyRoute = {
		state: navigationConstant.RESOURCES[indexNav].SUBMENUS[indexSubmenu].STATE,
		config: {
			url: navigationConstant.RESOURCES[indexNav].SUBMENUS[indexSubmenu].URL,
			templateUrl: pendingToConfirmCompanyTemplate,
			controller: 'PendingToConfirmCompanyController',
			controllerAs: 'pendingtoconfirmcompanyvm',
			resolve: {
				pendingToConfirmCompany: pendingToConfirmCompanyLazyLoading
			},
			data: {
				code: navigationConstant.RESOURCES[indexNav].SUBMENUS[indexSubmenu].CODE,
				login: true,
				pageTitle: navigationConstant.RESOURCES[indexNav].SUBMENUS[indexSubmenu].NAME,
				submenu: true
			},
		}
	}

	routerHelper.configureStates([pendingToConfirmCompanyRoute]);
}

/**
* Function for the lazyLoading configuration in the pendingToConfrim route.
*
* @param {any} $q
* @param {any} $ocLazyLoad
* @returns
*/
function pendingToConfirmCompanyLazyLoading($q, $ocLazyLoad) {
	'ngInject';

	const deferred = $q.defer();

	require.ensure([], require => {
		const pendingToConfirmCompanyModule = require('./pendingToConfirmCompany.module');

		$ocLazyLoad.load({
			name: pendingToConfirmCompanyModule.default.name,
		});

		deferred.resolve(pendingToConfirmCompanyModule.default.controller);
	});

	return deferred.promise;
}

export default angular
	.module('pendingToConfirmCompany.routes', [])
	.run(routeConfig);



// WEBPACK FOOTER //
// ./src/app/auth/components/pendingToConfirmCompany/pendingToConfirmCompany.routes.js